import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-gauge',
  templateUrl: './gauge.component.html',
})
export class GaugeComponent {
  @Input() listData: any;
  @Input() index: any;
  @Input() type: any;
  @Input() typeKpi:any;
  @Input('pageTab') pageTab: number = 0;
  @Input() cardUnit:any;
  view: any[] = [200, 300];
  data: any[];
  public selectedColorArray: Array<string> = [];

  constructor() {
    setTimeout(()=>{
             var arr=document.getElementsByClassName('media-card');
      var maxHeight=0;
         if (arr) {
           Array.prototype.forEach.call(arr, function (el) {
             el ? (el.getBoundingClientRect()['height']>maxHeight?maxHeight=el.getBoundingClientRect()['height']:'') : '';
           });
           Array.prototype.forEach.call(arr, function (el) {
             el ? (el.style.height=(maxHeight+'px')) : '';
           });
         }
           },100);

    let inter = setInterval(() => {

      if (this.listData) {
        clearInterval(inter);
        let val: number = this.listData && this.listData['scoreName'] && this.listData['scoreName'].length > 0 && this.listData[this.listData['scoreName']] && (this.listData[this.listData['scoreName']].length > 0) && this.listData[this.listData['scoreName']][0]['value']
          ? +(this.listData[this.listData['scoreName']][0]['value']) : 0;

        if (this.type && this.type == 'card')
          this.data = [{
            "name": this.listData && this.listData.telco && this.listData.telco[0] ? this.listData.telco[0] : 'All',
            "value": val
          }];
        else if (this.type && this.type == 'score')
          this.data = [{
            "name": this.listData['key'],
            "value": this.listData['value']
          }];
        if(this.typeKpi)
        this.selectedColorArray.push('rgb(248, 248, 250)');
        if (val < 2)
          this.selectedColorArray.push('#fa000a'); //red
        else if (val >= 2 && val <= 3)
          this.selectedColorArray.push('#ffa500'); // orange
        else
          this.selectedColorArray.push('#04e474'); //green
      }
    }, 100);
  }

  labelFormatter(event) {
    if (event) {
      let arr = ('' + event).split('.');
      if (arr[1] && arr[1].length > 1) {
        return event.toFixed(1);
      }

    }
  }

  ngDoCheck() {
    let element: any = document.getElementById('gauge' + this.pageTab + this.index);
    if (element) {
      let backGroundArc: any = element.getElementsByClassName('background-arc') ? element.getElementsByClassName('background-arc')[0] : '';
      if (backGroundArc) {
        backGroundArc.style.fill = "#f8f8fa";
      }
      let subElement = element.getElementsByTagName('tspan') ? element.getElementsByTagName('tspan')[0] : '';
      let subElements = element.getElementsByClassName('arc-group') ? element.getElementsByClassName('arc-group')[0] : '';

      if (subElement) {
        subElement.style.fontFamily = "Gotham";
        let value: any = subElement.innerHTML;
        if (value && !this.typeKpi) {
          subElement.innerHTML = (+value).toFixed(1);
        subElement.style.fill = this.selectedColorArray[0];
        }else{
          var valChnage:any = (+value).toFixed(1);
          if(!isNaN(valChnage)){
          let val:any = (+value).toFixed(1)+' '+this.cardUnit[this.listData['scoreName']];
          subElement.innerHTML =val ;
        subElement.style.fill = 'lightgray';
        subElement.style.fontSize = '34px';
          }
        }
      }
      let subElementTrans = element.getElementsByTagName('text') ? element.getElementsByTagName('text')[0] : '';
      if (subElementTrans && !isNaN(valChnage)) {
        subElementTrans.style.transform = "scale(0.65)";
        subElementTrans.style.translateY = "17px";
        subElementTrans.style.fontFamily = "Gotham";
        subElementTrans.style.fontSize = "5rem";
      }else{
        subElementTrans.style.translateY = "17px";
        subElementTrans.style.fontFamily = "Gotham";
      }
    }
  }
}


 
